export default Object.freeze({
    goldish: "#E69C20",
    grayish: "#D4D4D4",
    blackish: "#161616",
    creamWhite: "#F9F9F9",
    darkGrayish: "#6E6E6E",
    tanish: "#E8E5DC",
    darkTanish: "#A7A7A7"
});